// TNO D-score "normal" development range: lower and upper bound by age in
// years, from TNO's D-score reference data / calculator.
// https://tnochildhealthstatistics.shinyapps.io/dcalculator/
// https://www.tno.nl/nl/gezond/jeugd-gezondheid/eerste-1000-dagen-kind/d-score-ontwikkeling-kinderen/
export const DEVELOPMENT_NORM_BAND_BOUNDS: ReadonlyArray<readonly [age: number, lower: number, upper: number]> = [
  [0, 5.5128, 19.6534],
  [0.0191, 6.0563, 20.4303],
  [0.0383, 6.6148, 21.192],
  [0.0574, 7.1886, 21.9429],
  [0.0766, 7.7786, 22.6798],
  [0.0958, 8.3769, 23.3933],
  [0.1149, 8.9967, 24.1148],
  [0.1341, 9.6315, 24.8289],
  [0.1533, 10.285, 25.5586],
  [0.1724, 10.9555, 26.2804],
  [0.1916, 11.6372, 27.006],
  [0.2108, 12.3413, 27.7417],
  [0.2299, 13.0545, 28.4842],
  [0.2491, 13.7887, 29.2389],
  [0.2683, 14.5326, 29.9976],
  [0.2874, 15.289, 30.7566],
  [0.3066, 16.0635, 31.5303],
  [0.3258, 16.8438, 32.3118],
  [0.3449, 17.6325, 33.0967],
  [0.3641, 18.4404, 33.8935],
  [0.3832, 19.2417, 34.6882],
  [0.4024, 20.0576, 35.4772],
  [0.4216, 20.876, 36.2732],
  [0.4407, 21.6951, 37.0774],
  [0.4599, 22.518, 37.8651],
  [0.4791, 23.3308, 38.6502],
  [0.4982, 24.1381, 39.4272],
  [0.5174, 24.9376, 40.1778],
  [0.5366, 25.7289, 40.922],
  [0.5557, 26.5026, 41.6484],
  [0.5749, 27.2648, 42.3508],
  [0.5941, 28.0067, 43.0374],
  [0.6132, 28.7426, 43.7135],
  [0.6324, 29.4476, 44.3635],
  [0.6516, 30.1533, 44.9967],
  [0.6707, 30.834, 45.6171],
  [0.6899, 31.4974, 46.2177],
  [0.7091, 32.1505, 46.8107],
  [0.7282, 32.793, 47.3966],
  [0.7474, 33.4239, 47.9758],
  [0.7665, 34.0344, 48.5368],
  [0.7857, 34.6402, 49.1034],
  [0.8049, 35.2324, 49.6643],
  [0.824, 35.8209, 50.2112],
  [0.8432, 36.3948, 50.7529],
  [0.8624, 36.962, 51.3011],
  [0.8815, 37.5244, 51.8358],
  [0.9007, 38.0793, 52.3774],
  [0.9199, 38.629, 52.9057],
  [0.939, 39.1704, 53.4413],
  [0.9582, 39.7146, 53.9753],
  [0.9774, 40.2412, 54.5055],
  [0.9965, 40.762, 55.023],
  [1.0157, 41.2851, 55.539],
  [1.0349, 41.7898, 56.0518],
  [1.054, 42.3092, 56.5539],
  [1.0732, 42.797, 57.0625],
  [1.0924, 43.291, 57.5492],
  [1.1115, 43.7786, 58.0236],
  [1.1307, 44.2465, 58.4954],
  [1.1498, 44.7077, 58.9552],
  [1.169, 45.1621, 59.4029],
  [1.1882, 45.6185, 59.8499],
  [1.2073, 46.0596, 60.2738],
  [1.2265, 46.4885, 60.7071],
  [1.2457, 46.916, 61.1073],
  [1.2648, 47.3311, 61.5173],
  [1.284, 47.7391, 61.9155],
  [1.3032, 48.1547, 62.2918],
  [1.3223, 48.5401, 62.6557],
  [1.3415, 48.912, 63.0295],
  [1.3607, 49.2914, 63.3814],
  [1.3798, 49.6722, 63.7329],
  [1.399, 50.0218, 64.0723],
  [1.4182, 50.3878, 64.4008],
  [1.4373, 50.7309, 64.7284],
  [1.4565, 51.0663, 65.0447],
  [1.4757, 51.4026, 65.3606],
  [1.4948, 51.7312, 65.6651],
  [1.514, 52.052, 65.9582],
  [1.5331, 52.3737, 66.251],
  [1.5523, 52.6962, 66.5435],
  [1.5715, 52.9945, 66.8356],
  [1.5906, 53.3098, 67.1164],
  [1.6098, 53.6007, 67.397],
  [1.629, 53.8921, 67.6773],
  [1.6481, 54.1921, 67.9352],
  [1.6673, 54.4758, 68.2039],
  [1.6865, 54.7514, 68.4614],
  [1.7056, 55.0274, 68.7186],
  [1.7248, 55.3038, 68.9756],
  [1.744, 55.5807, 69.2322],
  [1.7631, 55.849, 69.4775],
  [1.7823, 56.1178, 69.7226],
  [1.8015, 56.3693, 69.9788],
  [1.8206, 56.6297, 70.2122],
  [1.8398, 56.8905, 70.4453],
  [1.859, 57.1337, 70.6898],
  [1.8781, 57.395, 70.9223],
  [1.8973, 57.6478, 71.1437],
  [1.9164, 57.8915, 71.3873],
  [1.9356, 58.1449, 71.6081],
  [1.9548, 58.3802, 71.8404],
  [1.9739, 58.6341, 72.0606],
  [1.9931, 58.8697, 72.2924],
  [2.0123, 59.1242, 72.512],
  [2.0314, 59.3601, 72.7433],
  [2.0506, 59.5873, 72.9635],
  [2.0698, 59.8426, 73.1825],
  [2.0889, 60.0702, 73.4022],
  [2.1081, 60.3084, 73.5989],
  [2.1273, 60.5365, 73.8183],
  [2.1464, 60.7649, 74.0376],
  [2.1656, 61.0042, 74.2338],
  [2.1848, 61.2242, 74.4419],
  [2.2039, 61.4447, 74.6499],
  [2.2231, 61.6653, 74.8578],
  [2.2422, 61.8975, 75.0426],
  [2.2614, 62.119, 75.2503],
  [2.2806, 62.332, 75.4471],
  [2.2997, 62.5454, 75.6438],
  [2.3189, 62.7798, 75.8283],
  [2.3381, 62.9942, 76.025],
  [2.3572, 63.2091, 76.2217],
  [2.3764, 63.4245, 76.4183],
  [2.3956, 63.6315, 76.6042],
  [2.4147, 63.839, 76.79],
  [2.4339, 64.0561, 76.9868],
  [2.4531, 64.2861, 77.1603],
  [2.4722, 64.4955, 77.3462],
  [2.4914, 64.7055, 77.5322],
  [2.5106, 64.9071, 77.7074],
  [2.5297, 65.1184, 77.8935],
  [2.5489, 65.3213, 78.0689],
  [2.5681, 65.5337, 78.255],
  [2.5872, 65.7379, 78.4305],
  [2.6064, 65.9426, 78.606],
  [2.6255, 66.1479, 78.7815],
  [2.6447, 66.3448, 78.9463],
  [2.6639, 66.5423, 79.1111],
  [2.683, 66.7181, 79.2887],
  [2.7022, 66.9165, 79.4536],
  [2.7214, 67.1065, 79.6079],
  [2.7405, 67.2969, 79.7621],
  [2.7597, 67.4788, 79.9056],
  [2.7789, 67.6387, 80.062],
  [2.798, 67.8214, 80.2055],
  [2.8172, 68.0046, 80.3491],
  [2.8364, 68.1791, 80.4818],
  [2.8555, 68.3313, 80.6277],
  [2.8747, 68.5066, 80.7604],
  [2.8939, 68.6503, 80.8956],
  [2.913, 68.8171, 81.0177],
  [2.9322, 68.9842, 81.1397],
  [2.9514, 69.1197, 81.2642],
  [2.9705, 69.2784, 81.3755],
  [2.9897, 69.4144, 81.5001],
  [3.0088, 69.5736, 81.6114],
  [3.028, 69.7101, 81.7359],
  [3.0472, 69.8607, 81.8365],
  [3.0663, 69.9886, 81.9504],
  [3.0855, 70.1398, 82.051],
  [3.1047, 70.268, 82.1648],
  [3.1238, 70.4105, 82.2547],
  [3.143, 70.5392, 82.3686],
  [3.1622, 70.6821, 82.4583],
  [3.1813, 70.8019, 82.5615],
  [3.2005, 70.9359, 82.6405],
  [3.2197, 71.0561, 82.7436],
  [3.2388, 71.1904, 82.8226],
  [3.258, 71.3016, 82.915],
  [3.2772, 71.4361, 82.9938],
  [3.2963, 71.5474, 83.0861],
  [3.3155, 71.6822, 83.1647],
  [3.3347, 71.7936, 83.257],
  [3.3538, 71.9052, 83.3492],
  [3.373, 72.031, 83.417],
  [3.3921, 72.1427, 83.5091],
  [3.4113, 72.2778, 83.5874],
  [3.4305, 72.3896, 83.6794],
  [3.4496, 72.5014, 83.7713],
  [3.4688, 72.646, 83.86],
  [3.488, 72.758, 83.9519],
  [3.5071, 72.8935, 84.0298],
  [3.5263, 73.0056, 84.1216],
  [3.5455, 73.1178, 84.2133],
  [3.5646, 73.2536, 84.291],
  [3.5838, 73.3458, 84.3971],
  [3.603, 73.4379, 84.5031],
  [3.6221, 73.5301, 84.6092],
  [3.6413, 73.6223, 84.7153],
  [3.6605, 73.7144, 84.8213],
  [3.6796, 73.8066, 84.9274],
  [3.6988, 73.8988, 85.0334],
  [3.718, 73.9909, 85.1395],
  [3.7371, 74.0831, 85.2455],
  [3.7563, 74.1753, 85.3516],
  [3.7754, 74.2674, 85.4576],
  [3.7946, 74.3596, 85.5637],
  [3.8138, 74.4518, 85.6697],
  [3.8329, 74.5439, 85.7758],
  [3.8521, 74.6361, 85.8818],
  [3.8713, 74.7283, 85.9879],
  [3.8904, 74.8204, 86.0939],
  [3.9096, 74.9126, 86.2],
  [3.9288, 75.0048, 86.306],
  [3.9479, 75.0969, 86.4121],
  [3.9671, 75.1891, 86.5182],
  [3.9863, 75.2813, 86.6242],
  [4.0054, 75.3734, 86.7303],
];
